module.exports = __webpack_public_path__ + "static/media/video.01260d7e.mp4";